/** An edit returns to the overview; a new listing continues its guided sequence. */
export function listingStepDestination<T extends string>(
  nextStep: T,
  entryMode: 'create' | 'edit',
  editReturnTo: T | null,
): T | 'review' {
  return editReturnTo ?? (entryMode === 'edit' ? 'review' : nextStep)
}
